<dialog-header [dialogRef]="dialogRef" headerKey="TASK_COPY"></dialog-header>
<div mat-dialog-content>
  <ng-container >
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <ng-container>
        <mat-form-field *ngIf="tasks === undefined || tasks.length > 0; else noTasks">
          <mat-label>{{ 'TASK' | translate }}</mat-label>
          <mat-select
            #multiSelect
            formControlName="taskId"
            [disabled]="!(tasks && tasks.length)"
            [multiple]="true"
          >
            <div class="fake-mat-option" (click)="toggleSelectAll()">{{(isAllSelected() ? 'DESELECT_ALL' : 'SELECT_ALL') | translate}}</div>
            <mat-divider></mat-divider>
            <div>
              <mat-option [ngClass]="{'copied': !!task.copiedFrom}" *ngFor="let task of tasks" [value]="task.id">
                {{ task.name }}
              </mat-option>
            </div>
          </mat-select>
          <mat-error>{{ 'FIELD_ERROR.TASK' | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <dialog-buttons submitLabel="COPY" [submitDisabled]="tasks && tasks.length === 0"></dialog-buttons>
    </form>
  </ng-container>
  <ng-template #noTasks>
    <div class="empty-list">
      <i>{{ 'NO_SIMILAR_TASKS' | translate }}</i>
    </div>
  </ng-template>
</div>
